module.exports = __webpack_public_path__ + "img/swipe-img1.f5e64bf7.png";